import { Document, Page, Text, View, pdf, Image } from "@react-pdf/renderer"
import logo from "../images/logo2.png"
import moment from "moment"

const PdfAvanceOrdenServicio = ({ data }) => {
  const splitArrayInChunks = (array, size) => {
    const result = []
    for (let i = 0; i < array.length; i += size) {
      let chunk = array.slice(i, i + size)

      // Si el chunk tiene menos de size, lo rellenamos con null
      while (chunk.length < size) {
        chunk.push(null)
      }

      result.push(chunk)
    }

    // Si el array está vacío, agregamos un chunk de puros null
    if (result.length === 0) {
      result.push(Array(size).fill(null))
    }

    return result
  }

  const pages = splitArrayInChunks(data[0].manosObraOrdenServicio, 20)
  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page
          size="A4"
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "70px 20px 0px 20px"
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-end",
              border: "1px solid black",
              padding: "2px 20px 2px 20px"
            }}
          >
            <Image
              src={logo}
              style={{
                width: 100
              }}
            />
            <Text
              style={{
                fontSize: 6,
                fontWeight: "bold"
              }}
            >
              FECHA: {moment().format("DD/MM/YYYY")}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              borderBottom: "1px solid black",
              borderLeft: "1px solid black",
              borderRight: "1px solid black",
              backgroundColor: "#D9D9D9",
              padding: "2px"
            }}
          >
            <Text
              style={{
                fontSize: 6,
                fontWeight: "bold"
              }}
            >
              DATOS DE LA UNIDAD
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              borderBottom: "1px solid black",
              borderLeft: "1px solid black",
              borderRight: "1px solid black",
              padding: "2px"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "50%",
                alignItems: "flex-end"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row"
                }}
              >
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold"
                  }}
                >
                  N° Eco:
                </Text>
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold",
                    borderBottom: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    width: "80%"
                  }}
                >
                  {data[0].checklists.datoschecklists.carros.economico}
                </Text>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row"
                }}
              >
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold"
                  }}
                >
                  Mod:
                </Text>
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold",
                    borderBottom: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    width: "80%"
                  }}
                >
                  {data[0].checklists.datoschecklists.carros.modelo}
                </Text>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "50%",
                alignItems: "flex-end"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row"
                }}
              >
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold"
                  }}
                >
                  Descripción:
                </Text>
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold",
                    borderBottom: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    width: "70%"
                  }}
                >
                  {data[0].checklists.datoschecklists.carros.descripcion}
                </Text>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row"
                }}
              >
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold"
                  }}
                >
                  N° Serie:
                </Text>
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold",
                    borderBottom: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    width: "70%"
                  }}
                >
                  {data[0].checklists.datoschecklists.carros.vin}
                </Text>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row"
                }}
              >
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold"
                  }}
                >
                  Marca:
                </Text>
                <Text
                  style={{
                    fontSize: 8,
                    fontWeight: "bold",
                    borderBottom: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    width: "70%"
                  }}
                >
                  {data[0].checklists.datoschecklists.carros.marca}
                </Text>
              </div>
            </div>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              borderBottom: "1px solid black",
              borderLeft: "1px solid black",
              borderRight: "1px solid black",
              backgroundColor: "#D9D9D9",
              padding: "2px"
            }}
          >
            <Text
              style={{
                fontSize: 6,
                fontWeight: "bold"
              }}
            >
              OBSERVACIONES GENERALES
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              fontSize: 6,
              flexWrap: "nowrap"
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  height: "30px"
                }}
              >
                <div
                  style={{
                    width: "15%",
                    borderBottom: "1px solid black",
                    borderRight: "1px solid black",
                    borderLeft: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Text>DESCRIPCIÓN</Text>
                </div>
                <div
                  style={{
                    width: "15%",
                    borderBottom: "1px solid black",
                    borderRight: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Text>SISTEMA A REPARAR</Text>
                </div>
                <div
                  style={{
                    width: "10%",
                    borderBottom: "1px solid black",
                    borderRight: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Text>NUMERO DE REQUISICION</Text>
                </div>
                <div
                  style={{
                    width: "15%",
                    borderBottom: "1px solid black",
                    borderRight: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Text>FECHA DE{"\n"}SOLICITUD</Text>
                </div>
                <div
                  style={{
                    width: "30%",
                    borderBottom: "1px solid black",
                    borderRight: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Text>ESTATUS</Text>
                </div>
                <div
                  style={{
                    width: "15%",
                    borderBottom: "1px solid black",
                    borderRight: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Text>FECHA DE{"\n"}TERMINACION</Text>
                </div>
              </div>
              {pageData.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      height: "20px"
                    }}
                  >
                    <div
                      style={{
                        width: "15%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        borderLeft: "1px solid black",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <Text>
                        {item === null ? "" : item.manosObra.descripcion}
                      </Text>
                    </div>
                    <div
                      style={{
                        width: "15%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <Text>{item === null ? "" : item.manosObra.tipo}</Text>
                    </div>
                    <div
                      style={{
                        width: "10%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <Text>
                        {item === null ? "" : item.manosObra.claveSat}
                      </Text>
                    </div>
                    <div
                      style={{
                        width: "15%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <Text>
                        {item === null
                          ? ""
                          : moment(data[0].fechaSolicitud).format("DD/MM/YYYY")}
                      </Text>
                    </div>
                    <div
                      style={{
                        width: "30%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <Text>{item === null ? "" : data[0].status}</Text>
                    </div>
                    <div
                      style={{
                        width: "15%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <Text>
                        {item === null
                          ? ""
                          : data[0].eliminado == null
                          ? "Sin Finalizar"
                          : moment(data[0].eliminado).format("DD/MM/YYYY")}
                      </Text>
                    </div>
                  </div>
                )
              })}
            </div>
          </View>
        </Page>
      ))}
    </Document>
  )
}

const blobToExport = async (data) => {
  return await pdf(<PdfAvanceOrdenServicio data={data} />).toBlob()
}

export default PdfAvanceOrdenServicio
